import { initialState } from 'store/MemberCommunication'

export const selectPoptartHistory = ({ MemberCommunication }) =>
  MemberCommunication?.requestFlows?.history ||
  initialState?.requestFlows?.history ||
  []

export const selectRequestTitle = ({ MemberCommunication }) =>
  MemberCommunication?.requestType?.entity?.title ||
  initialState?.requestType?.entity?.title ||
  ''

export const selectUnresolvedRequests = ({ MemberCommunication }) =>
  MemberCommunication?.unresolved?.entity?.unresolved ||
  initialState?.unresolved?.entity?.unresolved ||
  0

export const selectUnresolvedRequestsBusy = ({ MemberCommunication }) =>
  MemberCommunication?.unresolved?.busy ||
  initialState?.unresolved?.busy ||
  false
